import React, { useEffect, useState } from 'react';
import { makeStyles } from '@material-ui/styles';
import {
  TableContainer,
  Table,
  TableHead,
  TableRow,
  Menu,
  TableCell,
  TableBody,
  IconButton,
  Typography,
  CircularProgress, Chip, Tooltip, Avatar
} from '@material-ui/core';
import RTL from '../../../../components/RTL';
import mockData from './data';
import DeleteIcon from '@material-ui/icons/Delete';
import EditIcon from '@material-ui/icons/Edit';
import VisibilityIcon from '@material-ui/icons/Visibility';
import Pagination from '@material-ui/lab/Pagination';
import { useDispatch, useSelector } from 'react-redux';
import { Loading } from 'redux/Action';
import { axios } from './../../../../axios';
import { SearchInput } from 'components';

import Button from '@material-ui/core/Button';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Grow from '@material-ui/core/Grow';
import Paper from '@material-ui/core/Paper';
import Popper from '@material-ui/core/Popper';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from "@material-ui/icons/MoreVert";


const useStyles = makeStyles((theme) => ({
  imageContainer: {
    width: 140,
    height: 140,
    margin: 'auto',
    position: 'relative',
    overflow: 'unset',
  },
  searchInput: {
    padding: theme.spacing(2),
  },
  imageButton: {
    position: 'absolute',
    left: -15,
    bottom: -10,
  },
  image: {
    width: 110,
    height: 110,
  },
  input: {
    marginTop: theme.spacing(4),
  },
  imageInput: {
    display: 'none',
  },
  submitButtonIcon: {
    marginLeft: theme.spacing(2),
  },
  button: {
    margin: theme.spacing(1),
    color:'primary'
  },
}));
let filter_txt = '';



const SplitButton = ({options,driverId,childToParent}) => {
  const classes = useStyles();
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(1);

  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleMenuItemClick = (event, driverId) => {
    const { myValue } = event.currentTarget.dataset;
    console.log(myValue) // --> 123
    setAnchorEl(null);
    childToParent(myValue,driverId);
  };

 
  return (
    <div>
      <Button
        variant="outlined"
        color="primary"
        className={classes.button}
        onClick={handleClick}
        // endIcon={<MoreVertIcon style={{marginRight:10}} />}
      >
        فعال کردن
      </Button>
      <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={handleClose}>
        {options.map((option, index) => (
          <MenuItem
            key={option}
            data-my-value={option?.id}
            // selected={index === selectedIndex}
            onClick={(event) => handleMenuItemClick(event, driverId)}
          >
            {option?.alias}
          </MenuItem>
        ))}
      </Menu>
    </div>
  );
};


const DriverList = (props) => {
  const classes = useStyles();
  const {
    onDelete,
    onInfo,
    ChangeId,
    showEdit,
    reload,
    selData,
    del,
    edit,
    info,
  } = props;
  let Pr_inventory = useSelector((state) => state.permission);
  const current_role = useSelector((state) => state.role);

  const token = useSelector((state) => state.token);
  const [data, setData] = React.useState([]);
  const [LastPage, setLastPage] = React.useState(1);
  const [Page, setPage] = React.useState(1);
  const [filter, setFilter] = React.useState('');
  const dispatch = useDispatch();
const [Options, setOptions] = useState([]);



const childToParent = async(PlanId,driverId) => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };
  try {
    const resPlans = await axios.post(`plans/manually-activate`,{
      driver_id:parseInt(driverId),
      plan_id:parseInt(PlanId)
    }, {
      headers: headers,
    });

    dispatch(Loading());
    UpdateData();
  } catch (e) {
    dispatch(Loading());
  }
}

  const isLoading = useSelector((state) => state.isLoading);
  const handleChangePage = (event, value) => {
    setPage(value);
  };

  const headers = {
    Authorization: `Bearer ${token}`,
  };


  const UpdateData = async () => {
    try {

      const res = await axios.get(`drivers?cell=${filter_txt}&page=${Page}`, {
        headers: headers,
      });
      // console.log(res.data['0'])
      setLastPage(res.data['0'].last_page);
      if (LastPage == 1) {
        setPage(1);
      }
      setData([]);

      setData(res.data['0'].data);
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
    }

    //alert(res)
  };



  const GetData = async () => {
    try {
      const resPlans = await axios.get(`plans/paid`, {
        headers: headers,
      });
      setOptions(resPlans.data.plans);

      const res = await axios.get(`drivers?cell=${filter_txt}&page=${Page}`, {
        headers: headers,
      });
      // console.log(res.data['0'])
      setLastPage(res.data['0'].last_page);
      if (LastPage == 1) {
        setPage(1);
      }
      setData([]);

      setData(res.data['0'].data);
      dispatch(Loading());
    } catch (e) {
      dispatch(Loading());
    }

    //alert(res)
  };

  useEffect(() => {
    filter_txt = '';
    dispatch(Loading());
    GetData();
  }, [Page, reload]);

  const handleKeyDown = (event) => {
    setPage(1);
    if (event.key === 'Enter') {
      filter_txt = event.target.value;
      GetData();
      dispatch(Loading());
    }
  };

  return (
    <RTL>
      <>
        <div className={classes.searchInput}>
          <SearchInput
            onKeyDown={handleKeyDown}
            placeholder="شماره تماس راننده را وارد سپس کلید Enter  را بزنید"
          />
        </div>
        {!isLoading ? (
          <>
            {data ? (
              data.length > 0 ? (
                <TableContainer className={classes.tableContainer}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">نام راننده</TableCell>
                        <TableCell align="center">وضعیت پنل</TableCell>
                        <TableCell align="center">شهر محل سکونت</TableCell>
                        <TableCell align="center">نام ماشین</TableCell>
                        <TableCell align="center"> شماره تماس راننده</TableCell>
                        {current_role == 'Super-Admin' ||
                          (Pr_inventory.indexOf('manage-drivers.view') != -1 &&
                            Pr_inventory.indexOf('manage-drivers.delete') !=
                            -1) ||
                          Pr_inventory.indexOf('manage-drivers.edit') != -1 ? (
                            <TableCell align="center" sortDirection="desc">
                              عملیات
                            </TableCell>
                          ) : (
                            ''
                          )}
                      </TableRow>
                    </TableHead>
                    <TableBody className={classes.tableBody}>
                      {data.map((dt,index) => (
                        <TableRow hover key={dt.id}>
                          <TableCell align="center">
                            {dt.full_name != '' && dt.full_name != null
                              ? dt.full_name
                              : '-'}
                          </TableCell>
                          <TableCell align="center">
                          {dt.driver?.active_plans.length>0?
                          <Chip
                                    style={{
                                      backgroundColor: '#00b894',
                                      color: 'white',
                                      fontSize: 11,
                                    }}
                                    label={dt.driver?.active_plans['0']?.alias}
                                  />
                                    :
                                    <SplitButton options={Options} driverId={dt?.driver?.id} childToParent={childToParent}/>

                          }

     
      
                          </TableCell>
                          <TableCell align="center">
                            {console.log(dt.driver)}
                            {
                              dt.driver.city?.get_province?.name + " " + dt.driver.city?.name
                            }
                            {/* {dt.driver?.cities.length > 2 ?

                              <Tooltip
                                title={
                                  <div>
                                    {
                                      Object.values(dt.driver.cities).map((value, index) => (

                                        index === dt.driver.cities.length - 1 ? value.get_province?.name + " " + value.name : value.get_province?.name + " " + value.name + " | "
                                      ))

                                    }
                                  </div>
                                }
                                placement="bottom"
                                arrow
                              >
                                <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }} >
                                  <Avatar
                                    alt="شماره تماس"
                                    style={{
                                      width: 30,
                                      height: 30,
                                      borderRadius: 0,
                                    }}
                                    src="/images/citySvg.svg"
                                  />
                                </div>
                              </Tooltip>
                              : dt.driver?.cities.length > 0 ?
                                Object.values(dt.driver.cities).map((value, index) => (

                                  <Chip
                                    size="small"
                                    style={{
                                      backgroundColor: "#00b894",
                                      color: "white",
                                      margin: 5, fontSize: 10
                                    }}
                                    label={value.get_province?.name + " " + value.name}
                                  />
                                )) :


                                "-"} */}
                          </TableCell>
                          <TableCell align="center">
                            {dt.driver?.truck_model?.truck_type?.name ==
                              undefined
                              ? '- '
                              : dt.driver?.truck_model?.truck_type?.name +
                              ' - ' +
                              dt.driver?.truck_model?.name}
                          </TableCell>
                          <TableCell align="center">{dt.cell}</TableCell>
                          {current_role == 'Super-Admin' ||
                            Pr_inventory.indexOf('manage-drivers.delete') !=
                            -1 ||
                            Pr_inventory.indexOf('manage-drivers.edit') !=
                            -1 ? (
                              <TableCell align="center">
                                {current_role == 'Super-Admin' ||
                                  (Pr_inventory.indexOf('manage-drivers.view') !=
                                    -1 &&
                                    Pr_inventory.indexOf('manage-drivers.edit') !=
                                    -1) ? (
                                    <IconButton
                                      disabled={edit || del || info}
                                      style={
                                        edit || del || info
                                          ? { color: '#7f8c8d' }
                                          : { color: '#6c5ce7' }
                                      }
                                      onClick={() => {
                                        showEdit();
                                        ChangeId(dt.driver?.id);
                                        selData(
                                          data
                                            .filter((dts) => dts.id == dt.id)
                                            .map((filterData) => filterData)
                                        );
                                      }}
                                      color="error"
                                      aria-label="upload picture"
                                      component="span"
                                    >
                                      <EditIcon />
                                    </IconButton>
                                  ) : (
                                    ''
                                  )}
                                {current_role == 'Super-Admin' ||
                                  (Pr_inventory.indexOf('manage-drivers.view') !=
                                    -1 &&
                                    Pr_inventory.indexOf('manage-drivers.delete') !=
                                    -1) ? (
                                    <IconButton
                                      disabled={edit || del || info}
                                      style={
                                        edit || del || info
                                          ? { color: '#7f8c8d' }
                                          : { color: '#E65D62' }
                                      }
                                      onClick={() => {
                                        onDelete();
                                        ChangeId(dt.driver?.id);
                                        selData(
                                          data
                                            .filter((dts) => dts.id == dt.id)
                                            .map((filterData) => filterData)
                                        );
                                      }}
                                      color="error"
                                      aria-label="upload picture"
                                      component="span"
                                    >
                                      <DeleteIcon />
                                    </IconButton>
                                  ) : (
                                    ''
                                  )}
                              </TableCell>
                            ) : (
                              ''
                            )}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                  {LastPage > 1 ? (
                    <Pagination
                      style={{ margin: 10 }}
                      variant="outlined"
                      onChange={handleChangePage}
                      page={Page}
                      count={LastPage}
                      color="primary"
                    />
                  ) : (
                      ''
                    )}
                </TableContainer>
              ) : (
                  <div
                    style={{
                      display: 'flex',
                      flex: 1,
                      alignItems: 'center',
                      padding: 50,

                      height: '100%',
                      justifyContent: 'center',
                    }}
                  >
                    <Typography>متاسفانه هیچ رکوردی یافت نشد</Typography>
                  </div>
                )
            ) : (
                ''
              )}
          </>
        ) : (
            <div
              style={{
                display: 'flex',
                flex: 1,
                alignItems: 'center',
                height: '100%',
                justifyContent: 'center',
              }}
            >
              <CircularProgress size={24} />
            </div>
          )}
      </>
    </RTL>
  );
};

export default DriverList;
